export const ameixaPriceVariation = (newPrice, currentPrice) => {
  if (
    newPrice == null ||
    newPrice === "" ||
    currentPrice == null ||
    currentPrice === ""
  ) {
    return null;
  }
  const next = Number(newPrice);
  const current = Number(currentPrice);
  return Number.isFinite(next) && Number.isFinite(current) && current > 0
    ? (next - current) / current
    : null;
};

export const isAmeixaPriceVariationOrdering = ordering =>
  ordering === "variacao_ameixa_pct" || ordering === "-variacao_ameixa_pct";

export const sortByAmeixaPriceVariation = (rows, ordering) => {
  if (!isAmeixaPriceVariationOrdering(ordering)) return rows;
  const direction = ordering.startsWith("-") ? -1 : 1;
  // Use the displayed V5/equivalent prices and local edits before pagination.
  return [...rows].sort((a, b) => {
    const left = a.variacao_ameixa_pct;
    const right = b.variacao_ameixa_pct;
    if (left == null) return right == null ? 0 : 1;
    if (right == null) return -1;
    return (left - right) * direction;
  });
};
